import React, { useState, useEffect } from "react";
import RatingGame from "../../components/RatingGame";
import useGame from "../../hooks/useGame";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { navigate } from "@reach/router";
import LoadingScreen from "../../components/LoadingScreen";


function shuffleArray(array)
{
  for (let i = array.length - 1; i > 0; i--)
  {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function GenerateUniqueRandom(min, max, notthisArray) {
  var returnMe = Math.floor(Math.random() * (max - min) + min);
  console.log(notthisArray)

  if (notthisArray.includes(returnMe)) {
    return GenerateUniqueRandom(min, max, notthisArray);
  }

  return returnMe;
}

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

//Parameters are information about the number to be generated 
//[0] = min, 
//[1] = max, 
//[2] <=1 no set base, >1 = set base)
//[3]  <1 no max nominator, >= 1 is the max nominator
function GetFraction(param)
{
  var bottom, top = 0;
  if (parseInt(param[2]) > 1)
    bottom = parseInt(param[2])
  else
    bottom = Math.floor(param[0] + Math.random() * (param[1] - param[0]));

  top = Math.floor(1 + Math.random() * ((bottom - 1) / 2));

  if (parseInt(param[3]) > 0 && top > parseInt(param[3]))
    top = param[3]

  var frac = [top, bottom];
  return frac;
}

function AddHTML(string)
{
  var newText = string.toString().split(" ");
  for(var i = 0; i < newText.length; i++)
  {
    if(newText[i].includes('/'))
    {
      var tempString = newText[i].split("/");
      newText[i] = "<sup>" + tempString[0] + "</sup>&frasl;<sub>" + tempString[1] + "</sub>";
    }
  }
  return newText.join(" ");
}

export default function Rating({ ...props })
{
  const game = useGame(props.game.id);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [levels, setLevels] = useState();
  //console.log("Questions");
  console.log(questions);

  // once the questions have been retrieved we then generate the questionlist for the rating game
  useEffect(() =>
  {
    if (questions !== undefined)
    {
      let levelQs = [];
      questions.forEach((levelQuestions, i) =>
      {
        var newLevelQuestions = [];
        levelQuestions.forEach(q =>
        {
          for (var i = 1; i < 12; i++)
          {
            let generatedCalculation = [];
            let calc = parseInt(q.question_key.toString().replace("FracQ", ""));
            var correctAnswer = "";
            let wrongAnswers = [];
            
            let questionAnswers = [];

            var tempAnswer = "";
            if (calc <= 4)
            {
              var frac1, frac2, max, denom;

              //Simple addition
              if (calc === 1)
              {
                //Create correct Answer
                frac1 = GetFraction([3, 9, 0, 0]);
                frac2 = GetFraction([3, 9, frac1[1], (frac1[1] - frac1[2] - 1)]);
                //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
                tempAnswer = (parseInt(frac1[0]) + parseInt(frac2[0])) + "/" + frac1[1];
                
                correctAnswer = tempAnswer
                wrongAnswers.push(tempAnswer);

                //Question text =
                generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " + " + frac2[0] + "/" + frac2[1];
                max = frac1[1] + 2;
                denom = frac1[1];
              }
              if (calc === 2)
              {
                //Create correct Answer
                frac1 = GetFraction([3, 9, 0, 0]);
                frac2 = GetFraction([3, 9, frac1[1], (frac1[1] - frac1[2] - 1)]);

                //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
                tempAnswer = parseInt(frac1[0]) + "/" + frac1[1];
                correctAnswer = tempAnswer
                wrongAnswers.push(tempAnswer);

                //Question text =
                generatedCalculation[0] = (parseInt(frac1[0]) + parseInt(frac2[0])) + "/" + frac1[1] + " - " + frac2[0] + "/" + frac2[1];
                max = frac1[1] + 2;
                denom = frac1[1];
              }
              if (calc === 3)
              {

                //Create correct Answer
                frac1 = GetFraction([2, 6, 0, 0]);
                frac2 = GetFraction([3, 9, parseInt(frac1[1]) * 2], (frac1[1] - frac1[2] - 1) * 2);
                //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
                tempAnswer = (parseInt(frac1[0]) * 2 + parseInt(frac2[0])) + "/" + frac2[1];
                correctAnswer = tempAnswer
                wrongAnswers.push(tempAnswer);

                //Question text =
                generatedCalculation[0] = (frac1[0]) + "/" + frac1[1] + " + " + frac2[0] + "/" + frac2[1];
                max = frac2[1] + 2;
                denom = frac2[1];
              }
              else if (calc === 4)
              {

                //Create the question
                frac1 = GetFraction([2, 6, 0, 0]);
                frac2 = GetFraction([3, 9, parseInt(frac1[1]) * 2], (frac1[1] - frac1[2] - 1) * 2);

                //Correct answer is the second fration generated
                //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
                tempAnswer = frac2[0] + "/" + frac2[1];
                correctAnswer = tempAnswer
                wrongAnswers.push(tempAnswer);

                //Question text =
                generatedCalculation[0] = (parseInt(frac1[0]) * 2 + parseInt(frac2[0])) + "/" + frac2[1] + " - " + frac1[0] + "/" + frac1[1];
                max = frac2[1] + 2;
                denom = frac2[1];
              }
              //Create wrong answer
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  tempAnswer = Math.floor(1 + Math.random() * max) + "/" + denom;
                } while (wrongAnswers.includes(tempAnswer) === true)
                wrongAnswers.push(tempAnswer);
              }
            }
            //Adding integers to fractions
            else if (calc == 5)
            {
              var frac1 = GetFraction([2, 9, 0, 0]);
              var number = Math.floor(2 + Math.random() * 7);

              //Question text =
              generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " + " + number;

              correctAnswer = number + " " + frac1[0] + "/" + frac1[1];
              wrongAnswers.push(correctAnswer);
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  tempAnswer = (parseInt(number) - 1 + Math.floor(Math.random() * 3)) + " " + Math.floor(1 + Math.random() * frac1[1]) + "/" + (parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3));
                } while (wrongAnswers.includes(tempAnswer) === true)
                wrongAnswers.push(tempAnswer);
              }
            }
            //Subtracting fractions from integers
            else if (calc == 6)
            {
              var frac1 = GetFraction([2, 9, 0, 0]);
              var number = Math.floor(2 + Math.random() * 7);

              //Question text =
              generatedCalculation[0] = number + " - " + frac1[0] + "/" + frac1[1];

              correctAnswer = (parseInt(number) - 1) + " " + (parseInt(frac1[1]) - parseInt(frac1[0])) + "/" + frac1[1];
              wrongAnswers.push(correctAnswer);
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  tempAnswer = (parseInt(number) - 1 + Math.floor(Math.random() * 3)) + " " + Math.floor(1 + Math.random() * frac1[1]) + "/" + (parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3));
                } while (wrongAnswers.includes(tempAnswer) === true)
                wrongAnswers.push(tempAnswer);
              }
            }
            //Subtracting fractions from integers
            else if (calc == 7)
            {
              var frac1 = GetFraction([2, 6, 0, 0]);
              var divider = Math.floor(2 + Math.random() * 3);
              var base = (parseInt(frac1[1]) * divider);
              //Question text =
              generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " is equivalent to: ?/" + base;

              correctAnswer = (parseInt(frac1[0]) * divider) + "/" + base;
              wrongAnswers.push(correctAnswer);
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  tempAnswer = Math.floor(Math.random() * parseInt(frac1[1]) * divider) + "/" + base;
                } while (wrongAnswers.includes(tempAnswer) === true)
                wrongAnswers.push(tempAnswer);
              }
            }
            if (calc === 8)
            {
              //Create correct Answer
              frac1 = GetFraction([2, 5, 0, 0]);
              frac2 = GetFraction([2, 5, 0, 0]);

              //Question text =
              generatedCalculation[0] = "1/" + frac1[1] + " x " + "1/" + frac2[1];

              //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
              correctAnswer = "1/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
              wrongAnswers.push(correctAnswer);


              for (var n = 0; n < 3; n++)
              {
                do
                {
                  tempAnswer = "1/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
                } while (wrongAnswers.includes(tempAnswer) === true)
                wrongAnswers.push(tempAnswer);
              }
            }
            if (calc === 9)
            {
              //Create correct Answer
              frac1 = GetFraction([2, 5, 0, 0]);
              frac2 = GetFraction([4, 7, 0, 0]);
              frac2[0] = Math.floor(1 + Math.random() * (frac2[1] - 1));

              //Question text =
              generatedCalculation[0] = "1/" + frac1[1] + " x " + frac2[0] + "/" + frac2[1];

              //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
              correctAnswer = frac2[0] + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
              wrongAnswers.push(correctAnswer);


              for (var n = 0; n < 3; n++)
              {
                do
                {
                  if (Math.random() > 0.3)
                    tempAnswer = frac2[0] + "/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
                  else if (Math.random() > 0.5)
                    tempAnswer = (frac2[0] * frac1[1]) + "/" + (frac1[0] * frac2[1]);
                  else
                    tempAnswer = frac2[0] + "/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
                } while (wrongAnswers.includes(tempAnswer) === true)
                wrongAnswers.push(tempAnswer);
              }
            }
            if (calc === 10)
            {
              //Create correct Answer
              frac1 = GetFraction([4, 7, 0, 0]);
              frac2 = GetFraction([4, 7, 0, 0]);

              //Question text =
              generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " x " + frac2[0] + "/" + frac2[1];

              //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
              correctAnswer = (parseInt(frac1[0]) * parseInt(frac2[0])) + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
              wrongAnswers.push(correctAnswer);

              //Wrong answers
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  if (Math.random() > 0.3)
                    tempAnswer = ((parseInt(frac1[0]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[0]) - 1 + Math.floor(Math.random() * 3))) + "/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
                  else if (Math.random() > 0.5)
                    tempAnswer = (frac2[0] * frac1[1]) + "/" + (frac1[0] * frac2[1]);
                  else
                    tempAnswer = ((1 + Math.floor(Math.random() * 4)) * (1 + Math.floor(Math.random() * 4))) + "/" + ((4 + Math.floor(Math.random() * 3)) * (4 + Math.floor(Math.random() * 3)));
                } while (wrongAnswers.includes(tempAnswer) === true)
                wrongAnswers.push(tempAnswer);
              }
            }
            //Division questions
            if (calc === 11)
            {
              //generate question
              frac1 = GetFraction([2, 6, 0, 0]);
              frac2 = GetFraction([2, 6, 0, 0]);

              //Question text =
              generatedCalculation[0] = 1 + "/" + frac1[1] + " ÷ " + 1 + "/" + frac2[1];

              //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
              correctAnswer = frac2[1] + "/" + frac1[1];
              wrongAnswers.push(correctAnswer);

              //Wrong answers
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  if (Math.random() <= 0.5)
                    tempAnswer = ((parseInt(frac1[0]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[0]) - 1 + Math.floor(Math.random() * 3))) + "/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
                  else if (Math.random() > 0.5)
                    tempAnswer = (parseInt(frac2[0])) + "/" + (parseInt(frac1[1]));
                } while (wrongAnswers.includes(tempAnswer) === true || tempAnswer == "")
                wrongAnswers.push(tempAnswer);
              }
            }
            //Division questions
            if (calc === 12)
            {
              //generate question
              frac1 = GetFraction([2, 6, 0, 1]);
              frac2 = GetFraction([2, 6, 0, 0]);

              //Question text =
              generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " ÷ " + frac2[0] + "/" + frac2[1];

              //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
              correctAnswer = (frac2[1] * frac1[0]) + "/" + (frac1[1] * frac2[0]);
              wrongAnswers.push(correctAnswer);

              //Wrong answers
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  if (Math.random() <= 0.5)
                    tempAnswer = ((parseInt(frac1[0]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[0]) - 1 + Math.floor(Math.random() * 3))) + "/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
                  else if (Math.random() > 0.5){
                    tempAnswer = (parseInt(frac1[0]) * parseInt(frac2[0])) + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
                    console.log("never");
                  }
                  

                } while (wrongAnswers.includes(tempAnswer) === true || tempAnswer == "")

                if(tempAnswer == ""){
                  console.log(tempAnswer);
                  console.log(frac1,frac2);
                }

                wrongAnswers.push(tempAnswer);
              }
            }
            //Division questions
            if (calc === 13)
            {
              //generate question
              frac1 = GetFraction([2, 6, 0, 1]);
              frac1[0] = Math.floor(1 + Math.random() * (frac1[1] - 1));
              frac2 = GetFraction([3, 6, 0, 0]);
              frac2[0] = Math.floor(2 + Math.random() * (frac2[1] - 2));

              //Question text =
              generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " ÷ " + frac2[0] + "/" + frac2[1];

              //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
              correctAnswer = (frac2[1] * frac1[0]) + "/" + (frac1[1] * frac2[0]);
              wrongAnswers.push(correctAnswer);

              //Wrong answers
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  if (Math.random() <= 0.5)
                    tempAnswer = ((parseInt(frac1[0]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[0]) - 1 + Math.floor(Math.random() * 3))) + "/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
                  else if (Math.random() > 0.5)
                    tempAnswer = (parseInt(frac1[0]) * parseInt(frac2[0])) + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
                } while (wrongAnswers.includes(tempAnswer) === true || tempAnswer == "")
                wrongAnswers.push(tempAnswer);
              }
            }
            //Multiply an intiger by a fraction
            if (calc === 14)
            {
              var frac1 = GetFraction([2, 9, 0, 0]);
              var number = Math.floor(2 + Math.random() * 7);

              //Question text =
              generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " x " + number;

              correctAnswer = (number * frac1[0]) + "/" + frac1[1];
              wrongAnswers.push(correctAnswer);
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  if (Math.random() > 0.5)
                    tempAnswer = (parseInt(number) - 1 + Math.floor(Math.random() * 4)) * frac1[0] + "/" + (parseInt(frac1[1]));
                  else
                    tempAnswer = parseInt(number) * Math.floor(1 + Math.random() * frac1[0]) + "/" + (parseInt(frac1[1]));
                } while (wrongAnswers.includes(tempAnswer) === true)
                wrongAnswers.push(tempAnswer);
              }
            }
            //Divide a integer by a fraction
            if (calc === 15)
            {
              var frac1 = GetFraction([2, 6, 0, 0]);
              var number = Math.floor(2 + Math.random() * 4);

              //Question text =
              generatedCalculation[0] = number + " ÷ " + frac1[0] + "/" + frac1[1];

              correctAnswer = (number * frac1[1]) + "/" + frac1[0];
              wrongAnswers.push(correctAnswer);
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  if (Math.random() > 0.5)
                    tempAnswer = ((parseInt(number) - 1 + Math.floor(Math.random() * 3)) * frac1[0]) + "/" + frac1[1];
                  else
                    tempAnswer = (number * Math.floor(1 + Math.random()) * frac1[0]) + "/" + frac1[1];
                } while (wrongAnswers.includes(tempAnswer) === true)
                wrongAnswers.push(tempAnswer);
              }
            }
            //Decimals to fractions
            if (calc === 16)
            {
              var frac1 = GetFraction([2, 6, 0, 0]);
              frac1[0] = Math.floor(1 + Math.random() * (frac1[1] - 1));

              //Question text =
              generatedCalculation[0] = "Convert the following fraction to a decimal number: " + frac1[0] + "/" + frac1[1];

              correctAnswer = parseInt(frac1[0]) / parseInt(frac1[1]);
              correctAnswer = correctAnswer.toString().substr(0, 4);
              wrongAnswers.push(correctAnswer);
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  if (Math.random() > 0.5)
                    tempAnswer = ((parseInt(frac1[0]) - 1 + Math.floor(Math.random() * 3))) / frac1[1];
                  else
                    tempAnswer = frac1[0] / (frac1[1] - 1 + Math.floor(Math.random() * 3));
                  tempAnswer = tempAnswer.toString().substr(0, 4);
                } while (wrongAnswers.includes(tempAnswer) === true)
                wrongAnswers.push(tempAnswer);
              }
            }
            //Fractions to percentages
            if (calc === 17)
            {
              var frac1 = GetFraction([2, 6, 0, 0]);
              frac1[0] = Math.floor(1 + Math.random() * (frac1[1] - 1));

              //Question text =
              generatedCalculation[0] = "Convert the following fraction to a percentage: " + frac1[0] + "/" + frac1[1];

              correctAnswer = parseInt(frac1[0]) / parseInt(frac1[1]);
              correctAnswer = (parseFloat(correctAnswer.toString().substr(0, 4)) * 100.0) + "%";
              wrongAnswers.push(correctAnswer);
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  if (Math.random() > 0.5)
                    tempAnswer = ((parseInt(frac1[0]) - 1 + Math.floor(Math.random() * 3))) / frac1[1];
                  else
                    tempAnswer = frac1[0] / (frac1[1] - 1 + Math.floor(Math.random() * 3));
                  tempAnswer = (parseFloat(tempAnswer.toString().substr(0, 4)) * 100) + "%";
                } while (wrongAnswers.includes(tempAnswer) === true)
                wrongAnswers.push(tempAnswer);
              }
            }
            //Decimals to fractions
            if (calc === 18)
            {
              var frac1 = GetFraction([2, 6, 0, 1]);

              var temp = parseInt(frac1[0]) / parseInt(frac1[1]);
              temp = temp.toString().substr(0, 4);

              //Question text =
              generatedCalculation[0] = "Convert the following decimal to a fraction: " + temp;

              correctAnswer = frac1[0] + "/" + frac1[1];
              wrongAnswers.push(correctAnswer);

              for (var n = 0; n < 3; n++)
              {
                do
                {
                  if (Math.random() > 0.5)
                    tempAnswer = "1/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)));
                  else
                    tempAnswer = "1/" + (Math.floor(Math.random() * 6));
                } while (wrongAnswers.includes(tempAnswer) === true || tempAnswer === "1/0" || tempAnswer === "1/1")
                wrongAnswers.push(tempAnswer);
              }
            }
            //Decimals to percentages
            if (calc === 19)
            {
              var num = (0.1 + Math.random() * 0.9).toString().substr(0, 4);
              generatedCalculation[0] = "Convert the following decimal to a percentage: " + num;
              correctAnswer = Math.round(parseFloat(num) * 100) + "%";
              wrongAnswers.push(correctAnswer);
              var divider = 1;
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  tempAnswer = (parseFloat(num) * divider).toString().substr(0, 4) + "%";
                  divider = divider * 10;
                  if(tempAnswer.includes(".0%")){
                    tempAnswer = tempAnswer.replace('.0%', '%');
                    console.log(tempAnswer);
                  }
                } while (wrongAnswers.includes(tempAnswer) === true)
                wrongAnswers.push(tempAnswer);
              }
            }
            //Percentages to fractions
            if (calc === 20)
            {
              var frac1 = GetFraction([2, 6, 0, 1]);

              var temp = parseInt(frac1[0]) / parseInt(frac1[1]);
              temp = Math.round(parseFloat(temp.toString().substr(0, 4)) * 100) + "%";

              //Question text =
              generatedCalculation[0] = "Convert the following decimal to a fraction: " + temp;

              correctAnswer = frac1[0] + "/" + frac1[1];
              wrongAnswers.push(correctAnswer);

              for (var n = 0; n < 3; n++)
              {
                do
                {
                  if (Math.random() > 0.5)
                    tempAnswer = "1/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)));
                  else
                    tempAnswer = "1/" + (Math.floor(Math.random() * 6));
                } while (wrongAnswers.includes(tempAnswer) === true || tempAnswer === "1/0" || tempAnswer === "1/1")
                wrongAnswers.push(tempAnswer);
              }
            }
            //Percentages to deciamals
            if (calc === 21)
            {
              var num = (0.1 + Math.random() * 0.9).toString().substr(0, 4);
              generatedCalculation[0] = "Convert the following percentage to a decimal: " + Math.round(parseFloat(num) * 100) + "%";
              correctAnswer = num;
              wrongAnswers.push(correctAnswer);
              var divider = 1000;
              for (var n = 0; n < 3; n++)
              {
                do
                {
                  tempAnswer = (parseFloat(num) * divider).toString().substr(0, 4);
                  divider = divider / 10;
                } while (wrongAnswers.includes(tempAnswer) === true)
                wrongAnswers.push(tempAnswer);
              }
            }
            //Rounding decimals to 1dp
            if (calc === 22)
            {
              var wholeNum = GenerateRandom(1,8);
              var dec1Number = Math.round(GenerateRandom(10,80)/10)*10;
              var dec2Number = GenerateRandom(1,9);
              var num = parseFloat((wholeNum + (dec1Number/100)+(dec2Number/100)).toFixed(2));
              /*var num = (1.1 + Math.random() * 8.9).toString().substr(0, 4);
              if (num - Math.floor(num) < 0.11)
                num = parseFloat(num) + 0.11;
              if (num.toString()[3] === '0')
                num += 0.01;*/
              generatedCalculation[0] = "Round the following number to 1 decimal place: " + num;

              correctAnswer = Math.round(num * 10) / 10;
              wrongAnswers.push(correctAnswer);
              tempAnswer = Math.round((correctAnswer + 0.1) * 10) / 10;
              wrongAnswers.push(tempAnswer);
              tempAnswer = Math.round((correctAnswer - 0.1) * 10) / 10;
              wrongAnswers.push(tempAnswer);
              tempAnswer = (Math.round((num * 10) * 10) / 10).toString().substr(1);
              tempAnswer = tempAnswer.replace('.','');
              wrongAnswers.push(tempAnswer);
            }
            //Rounding decimals to 2dp
            if (calc === 23)
            {
              var wholeNum = GenerateRandom(1,8);
              var dec1Number = Math.round(GenerateRandom(10,80)/10)*10;
              var dec2Number = GenerateRandom(1,8);
              var dec3Number = GenerateRandom(1,9);
              var num = parseFloat((wholeNum + (dec1Number/100)+(dec2Number/100)+(dec3Number/1000)).toFixed(3));
              /*
              var num = (1.11 + Math.random() * 8.9).toString().substr(0, 5);
              if (num - Math.floor(num) < 0.111)
                num = parseFloat(num) + 0.111;
                */
              generatedCalculation[0] = "Round the following number to 2 decimal places: " + num;

              correctAnswer = Math.round(num * 100) / 100;
              wrongAnswers.push(correctAnswer);
              tempAnswer = Math.round((correctAnswer + 0.01) * 100) / 100;
              wrongAnswers.push(tempAnswer);
              tempAnswer = Math.round((correctAnswer - 0.01) * 100) / 100;
              wrongAnswers.push(tempAnswer);
              tempAnswer = (Math.round((num * 10) * 100) / 100).toString().substr(1);
              wrongAnswers.push(tempAnswer);
            }
            //Adding decimals
            if (calc === 24)
            {
              var dec1 = (0.11 + Math.random() * 0.34).toString().substr(0, 4);
              var dec2 = (0.11 + Math.random() * 0.34).toString().substr(0, 4);
              var answer = parseFloat(dec1) + parseFloat(dec2);
              answer = Math.round(answer * 100) / 100;
              generatedCalculation[0] = dec1 + " + " + dec2 + " = ";
              correctAnswer = answer;
              wrongAnswers.push(correctAnswer);

              for (var n = 0; n < 3; n++)
              {
                do
                {
                  tempAnswer = (parseFloat(correctAnswer) + (Math.random() * 0.5 - 0.25)).toString().substr(0, 4);;
                  tempAnswer = parseFloat(tempAnswer);
                } while (wrongAnswers.includes(tempAnswer) === true || tempAnswer <= 0 || tempAnswer >= 1)
                wrongAnswers.push(tempAnswer);
              }
            }
            //Subracting decimals
            if (calc === 25)
            {
              var dec1 = (0.61 + Math.random() * 0.34).toString().substr(0, 4);
              var dec2 = (0.11 + Math.random() * 0.3).toString().substr(0, 4);
              var answer = parseFloat(dec1) - parseFloat(dec2);
              answer = Math.round(answer * 100) / 100;
              generatedCalculation[0] = dec1 + " - " + dec2 + " = ";
              correctAnswer = answer;
              wrongAnswers.push(correctAnswer);

              for (var n = 0; n < 3; n++)
              {
                do
                {
                  tempAnswer = (parseFloat(correctAnswer) + (Math.random() * 0.5 - 0.25)).toString().substr(0, 4);;
                  tempAnswer = parseFloat(tempAnswer);
                } while (wrongAnswers.includes(tempAnswer) === true || tempAnswer <= 0 || tempAnswer >= 1)
                wrongAnswers.push(tempAnswer);
              }
            }
            //Multiplying decimals
            if (calc === 26)
            {
              let options = [0.2, 0.25, 0.4, 0.5, 0.75];
              var dec1 = options[Math.floor(Math.random() * options.length)];
              var dec2 = (0.4 + Math.random() * 0.3).toString().substr(0, 3);
              var answer = parseFloat(dec1) * parseFloat(dec2);
              answer = Math.round(answer * 100) / 100;
              generatedCalculation[0] = dec1 + " x " + dec2 + " = ";
              correctAnswer = answer;
              wrongAnswers.push(correctAnswer);

              for (var n = 0; n < 3; n++)
              {
                do
                {
                  tempAnswer = (parseFloat(correctAnswer) + (Math.random() * 0.5 - 0.25)).toString().substr(0, 4);;
                } while (wrongAnswers.includes(tempAnswer) === true || parseFloat(tempAnswer) <= 0 || parseFloat(tempAnswer) >= 1)
                wrongAnswers.push(tempAnswer);
              }
            }
            //Dividing integers by decimals
            if (calc === 27)
            {
              let options = [0.25, 0.5, 0.2];
              var dec1 = options[Math.floor(Math.random() * options.length)];
              var dec2 = Math.round(1 + Math.random() * 5);
              var answer = parseInt(dec2) / parseFloat(dec1);
              answer = Math.round(answer * 100) / 100;
              generatedCalculation[0] = dec2 + " ÷ " + dec1 + " = ";
              correctAnswer = answer;
              wrongAnswers.push(correctAnswer);

              for (var n = 0; n < 3; n++)
              {
                do
                {
                  tempAnswer = (parseFloat(correctAnswer) + Math.round(Math.random() * 15) - 7);
                } while (wrongAnswers.includes(tempAnswer) === true || parseFloat(tempAnswer) <= 0)
                wrongAnswers.push(tempAnswer);
              }
            }
            if (calc == 28){//percentage of a number
              var perc = GenerateRandom(1,99);
              var number = GenerateRandom(1,9)*100;
              var answer = (number/100)*perc ;
              generatedCalculation[0] = "What is "+perc+"% of "+number+" ?";
              correctAnswer = answer;
              wrongAnswers.push(correctAnswer);

              for (var n = 0; n < 3; n++)
              {

                do
                {
                  tempAnswer = correctAnswer + GenerateRandom(-5,5);
                } while (wrongAnswers.includes(tempAnswer))

                wrongAnswers.push(tempAnswer);
              }
              console.log(wrongAnswers);
            }
            if (calc == 29) {//adding mixed numbers
              var num1 = GenerateRandom(1, 9);
              var f1bottom = GenerateRandom(2, 5);
              var f2bottom = f1bottom * 2;
              var f1top = GenerateRandom(1, f1bottom);
              var f2top = GenerateRandom(2, f2bottom);
              var ans;
              var ansInt = num1;
          
              //calc answer
              if (((f1top * 2) + f2top) == f2bottom) {
                console.log("you right");
                console.log(f2top);
                f2top = f2top-1;
                console.log(f2top);
                ans = (f1top * 2) + f2top;
              }
              else if (((f1top * 2) + f2top) > f2bottom) {
                ansInt = ansInt+1;
                ans = ((f1top * 2) + f2top) - f2bottom;
              }
              else {
                ans = (f1top * 2) + f2top;
              }
              console.log(ans);

              generatedCalculation[0] = num1 + " " + f1top + "/" + f1bottom + " + " + f2top + "/" + f2bottom + " = " + ansInt + " " + "?/"+f2bottom;
              correctAnswer = ans;

              wrongAnswers.push(correctAnswer);

              for (var n = 0; n < 3; n++)
              {
                tempAnswer = GenerateUniqueRandom(correctAnswer-5,correctAnswer+5,wrongAnswers);
                wrongAnswers.push(tempAnswer);
              }
              console.log(wrongAnswers);
            }

            if (calc == 30) {//subtracting mixed numbers

              //generate fractions
              var num1 = GenerateRandom(1, 9);
              var f1bottom = GenerateRandom(2, 5);
              var f2bottom = f1bottom * 2;
              var f1top = GenerateRandom(1, f1bottom);
              var f2top = GenerateRandom(1, f2bottom);
              var ans;
              var ansInt = num1;
          
              //calc answer
              if (((f1top * 2) - f2top) == 0) {
                f2top = f2top-1;
                ans = (f1top * 2) - f2top;
              }
              else if (((f1top * 2) - f2top) < 0) {
                ansInt = ansInt-1;
                ans = f2bottom - (f2top - (f1top * 2));
              }
              else {
                ans = (f1top * 2) - f2top;
              }
              console.log(ans);
          
              generatedCalculation[0] = num1 + " " + f1top + "/" + f1bottom + " - " + f2top + "/" + f2bottom + " = " + ansInt + " " + "?/"+f2bottom;
              correctAnswer = ans;

              wrongAnswers.push(correctAnswer);

              for (var n = 0; n < 3; n++)
              {
                tempAnswer = GenerateUniqueRandom(correctAnswer-5,correctAnswer+5,wrongAnswers);
                wrongAnswers.push(tempAnswer);
              }
              console.log(wrongAnswers);
            }
            

            let questionText = generatedCalculation.join(" ");
            questionText = AddHTML(questionText);
            //let correctAnswer = getAnswer(generatedCalculation);
            for (var n = 0; n < 4; n++) 
            {
              console.log(wrongAnswers);
                questionAnswers.push({
                correct: n === 0,
                value: AddHTML(wrongAnswers[n].toString())
              });
              console.log(questionAnswers);
            }
            for(let i = 1; i < 4; i++){
              for(let j = 0; j < i; j++){
                if(i != j){
                  if(questionAnswers[j].value + '0' == questionAnswers[i].value || questionAnswers[j].value == questionAnswers[i].value){
                    console.log(questionAnswers[i].value);
                    questionAnswers[i].value *= 2;
                  }
                }
              }
            }
          shuffleArray(questionAnswers);

          let questionObj = {
            question: questionText,
            answers: questionAnswers,
            topic_id: q.topic_id
          };

          newLevelQuestions.push(questionObj);
          }
        });
        console.log(newLevelQuestions);
        shuffleArray(newLevelQuestions);
        levelQs[i] = newLevelQuestions;
      });
      setLevels(levelQs);
    }
  }, [questions]);

  return levels !== undefined ? (
    <RatingGame
      questionslist={levels}
      onBack={() =>
      {
        navigate(`/games/${game.id}`);
      }}
      game={game}
      endless={props.endless}
      initialLevel={props.initialLevel}
    />
  ) : (
      <LoadingScreen />
    );
}
